import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const uiSlice = createSlice({
  name: "ui",
  initialState: { modalEntryId: null as string | null },
  reducers: {
    openEntryModal(state, action: PayloadAction<string>) {
      state.modalEntryId = action.payload;
    },
    closeEntryModal(state) {
      state.modalEntryId = null;
    },
  },
});

export const { openEntryModal, closeEntryModal } = uiSlice.actions;
export default uiSlice.reducer;
